import { FaSort, FaDownload } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';
import { handleError } from '../utils/errorHandler';
import { colorsRangeHex, formatNumber } from '../Transversal';
import { DEFAULT_FILTER, ArcFiltros } from '../Detalles/SesionDetalles';
import { API_URL, HEIGHT_BODY, WIDTH_RIGHT_PANEL, COLOR_FONT_TITLE } from '../Config';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { useAppState } from './GraficoContext';
import { apiFetch } from '../apiClient';

let filterregrescarFiltros = 0;

interface SumaRuralUrbano {
    totalPoblacion?: number;
    rural?: number;
    urbano?: number;
}

interface BarraProps {
    filtrar: string;
    codigoDivipola: string;
    indicador: any
}
// rgb(106, 180, 157);

const COLORS = ['#88C4B3', '#628BB6', '#f8d107', '#ad7390'];

const RuralUrbano: React.FC<BarraProps> = ({ filtrar, codigoDivipola, indicador }) => {
    const { tieneRuralUrbano, setTieneRuralUrbano } = useAppState();
    const [sumaRuralUrbano, setdivipolaCantidad] = useState<SumaRuralUrbano>();
    const [cantidadNacional, setCantidadNacional] = useState<number>(0);
    let cargado = false;

    const fetchDatos = async () => {
        try {
            const startTime = performance.now();
            const queryString = Object.keys(DEFAULT_FILTER)
                .filter(key => DEFAULT_FILTER[key as keyof ArcFiltros] !== undefined)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros] ?? '')}`)
                .join('&');
            const url = `${API_URL}/ArcIndicador/GetSumaRuralUrbano?${queryString}`
            const response = await apiFetch(url);
            const data = await response.json();
            const cantidadNacionalNuevo = 0;
            cargado = true;
            setCantidadNacional(cantidadNacionalNuevo);
            setdivipolaCantidad(data);
            const endTime = performance.now();
            const duration = endTime - startTime;
            console.log(`Barras Fetch duration: ${duration} ms`);
        } catch (error) {
            handleError(error);
        }
    };

    const getDatos = async () => {
        console.log(DEFAULT_FILTER);
        if (DEFAULT_FILTER.regrescarFiltros != filterregrescarFiltros) {
            filterregrescarFiltros = DEFAULT_FILTER.regrescarFiltros;
            if (indicador != "") {
                fetchDatos();
            }
        }
    }

    useEffect(() => {
        getDatos();
    }, [filtrar, codigoDivipola, indicador]);

    const total = sumaRuralUrbano?.totalPoblacion || 0;
    const ruralPorcentaje = ((sumaRuralUrbano?.rural || 0) / total) * 100;
    const urbanoPorcentaje = ((sumaRuralUrbano?.urbano || 0) / total) * 100;
    const totalRuralUrbano = (sumaRuralUrbano?.rural || 0) + (sumaRuralUrbano?.urbano || 0);

    useEffect(() => {
        if (totalRuralUrbano === 0 || isNaN(totalRuralUrbano)) {
            if (sumaRuralUrbano) {
                setTieneRuralUrbano(false);
            }
        } else {
            setTieneRuralUrbano(true);
        }
    }, [totalRuralUrbano, sumaRuralUrbano]);

    if (totalRuralUrbano === 0 || isNaN(totalRuralUrbano)) {
        return <div></div>;
    }


    const data = [
        { name: 'Rural', value: ruralPorcentaje },
        { name: 'Urbano', value: urbanoPorcentaje },
    ];

    const RADIAN = Math.PI / 180;

    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }: any) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.25;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        return (
            <text x={x} y={y} fill="black" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" fontSize="12">
                <tspan x={x} dy="-5">{data[index].name}</tspan>
                <tspan x={x} dy="12">{`${formatNumber(percent * 100)}%`}</tspan>
            </text>
        );
    };

    return (
        <div style={{  alignItems: 'center', backgroundColor: '#fff', borderTop: '1px solid #ccc', float: 'left', margin: '10px 10px 0px 10px', padding: '5px 5px 5px 5px', width: '330px', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', height: '180px' }}>
            <div style={{width:"100%"}}><h3 style={{ color: "#2c66a4", fontWeight: 'bold' }}>Distribución Rural/Urbano</h3></div>
            <div style={{width:"100%"}}>
                <div style={{float:"left"}}>
                <PieChart width={150} height={150}>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={renderCustomizedLabel}
                        outerRadius={60}
                        fill="#8884d8"
                        dataKey="value">
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Tooltip formatter={(value: number) => formatNumber(value)} />
                </PieChart>
                </div>
                <div style={{ marginLeft: '20px', color: "#2c66a4", fontWeight: 'bold', textAlign: 'center',paddingTop:20}}>
                    <div style={{ marginBottom: '10px' }}>
                        <div>Rural</div>
                        <div style={{ color: 'black' }}>{formatNumber(sumaRuralUrbano?.rural || 0)}</div>
                    </div>
                    <div>
                        <div>Urbano</div>
                        <div style={{ color: 'black' }}>{formatNumber(sumaRuralUrbano?.urbano || 0)}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RuralUrbano;